import { createRouter, createWebHistory } from 'vue-router'

const seoMeta = {
  home: {
    en: {
      title: 'RUCSCO | Integrated Business Solutions in Riyadh & Dubai',
      description: 'RUCSCO empowers businesses with expert services in logistics, contracts, tax, banking, real estate, and commercial brokerage across the GCC.',
      keywords: 'RUCSCO, Business Services, Logistics, Commercial Brokerage, Riyadh, Dubai, GCC'
    },
    ar: {
      title: 'RUCSCO | حلول أعمال متكاملة في الرياض ودبي',
      description: 'RUCSCO تمكّن الشركات بخدمات متخصصة في اللوجستيات والعقود والضرائب والبنوك والعقارات والوساطة التجارية في دول الخليج.',
      keywords: 'RUCSCO, خدمات أعمال, لوجستيات, وساطة تجارية, الرياض, دبي, الخليج'
    }
  },
  blog: {
    en: {
      title: 'Blog | RUCSCO',
      description: 'Stay updated with the latest insights, news, and articles from RUCSCO on business solutions, logistics, and investment opportunities.',
      keywords: 'RUCSCO blog, business insights, GCC news, investment articles'
    },
    ar: {
      title: 'المدونة | RUCSCO',
      description: 'تابع أحدث المقالات والأخبار من RUCSCO حول حلول الأعمال واللوجستيات وفرص الاستثمار.',
      keywords: 'مدونة RUCSCO, رؤى أعمال, أخبار الخليج, مقالات استثمار'
    }
  },
  blog_one: {
    en: {
      title: 'Blog | RUCSCO',
      description: 'Read the latest article from RUCSCO.'
    },
    ar: {
      title: 'المدونة | RUCSCO',
      description: 'اقرأ أحدث مقالة من RUCSCO.'
    }
  },
  services: {
    en: {
      title: 'Our Services | RUCSCO',
      description: 'Explore RUCSCO\'s full range of business services including logistics, contract drafting, tax solutions, banking support, commercial brokerage, and real estate.',
      keywords: 'business services, logistics, contracts, tax, banking, real estate, commercial brokerage'
    },
    ar: {
      title: 'خدماتنا | RUCSCO',
      description: 'استكشف مجموعة خدمات RUCSCO الكاملة بما في ذلك اللوجستيات وصياغة العقود والحلول الضريبية والدعم المصرفي والوساطة التجارية والعقارات.',
      keywords: 'خدمات أعمال, لوجستيات, عقود, ضرائب, بنوك, عقارات, وساطة تجارية'
    }
  },
  contact: {
    en: {
      title: 'Contact Us | RUCSCO',
      description: 'Get in touch with RUCSCO for business consultations, partnerships, and inquiries. We are here to help your business grow.',
      keywords: 'contact RUCSCO, business consultation, Riyadh, Dubai'
    },
    ar: {
      title: 'تواصل معنا | RUCSCO',
      description: 'تواصل مع RUCSCO للاستشارات التجارية والشراكات والاستفسارات. نحن هنا لمساعدة عملك على النمو.',
      keywords: 'تواصل RUCSCO, استشارات أعمال, الرياض, دبي'
    }
  },
  morocco: {
    en: {
      title: 'Morocco Gateway | RUCSCO',
      description: 'Your smart gateway to the Kingdom of Morocco. Explore investment, real estate, tourism, and business expansion opportunities with RUCSCO.',
      keywords: 'Morocco investment, Morocco real estate, Morocco business, Morocco gateway, RUCSCO Morocco'
    },
    ar: {
      title: 'بوابة المغرب | RUCSCO',
      description: 'بوابتك الذكية إلى المملكة المغربية. استكشف فرص الاستثمار والعقارات والسياحة والتوسع التجاري مع RUCSCO.',
      keywords: 'استثمار المغرب, عقارات المغرب, أعمال المغرب, بوابة المغرب, RUCSCO المغرب'
    }
  },
  about: {
    en: {
      title: 'About Us | RUCSCO',
      description: 'Learn about RUCSCO — a leading provider of integrated business solutions in Riyadh, Dubai, and across the GCC region.',
      keywords: 'about RUCSCO, business solutions, Riyadh, Dubai, GCC'
    },
    ar: {
      title: 'من نحن | RUCSCO',
      description: 'تعرف على RUCSCO — مزود رائد لحلول الأعمال المتكاملة في الرياض ودبي وعبر منطقة الخليج.',
      keywords: 'عن RUCSCO, حلول أعمال, الرياض, دبي, الخليج'
    }
  },
  notFound: {
    en: { title: 'Page Not Found | RUCSCO' },
    ar: { title: 'الصفحة غير موجودة | RUCSCO' }
  }
};

function getSeo(key) {
  const lang = localStorage.getItem('lang') || 'en';
  return seoMeta[key]?.[lang] || seoMeta[key]?.en || {};
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
    meta: { seoKey: 'home' }
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import(/* webpackChunkName: "blog" */ '../views/Blog.vue'),
    meta: { seoKey: 'blog' }
  },
  {
    path: '/blog/:slug',
    name: 'blog_one',
    component: () => import(/* webpackChunkName: "blog" */ '../views/OneBlog.vue'),
    meta: { seoKey: 'blog_one' }
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import(/* webpackChunkName: "services" */ '../views/Services.vue'),
    meta: { seoKey: 'services' }
  },
  {
    path: '/contact-us',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
    meta: { seoKey: 'contact' }
  },
  {
    path: '/morocco-gateway',
    name: 'MoroccoGateway',
    component: () => import(/* webpackChunkName: "morocco-gateway" */ '../views/MoroccoGateway.vue'),
    meta: { seoKey: 'morocco' }
  },
  {
    path: '/about-us',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: { seoKey: 'about' }
  },
  {
    path: '/404',
    name: 'NotFoundError',
    component: () => import(/* webpackChunkName: "error" */ '../components/Error404/Error404.vue'),
    meta: { hideNavFooter: true, seoKey: 'notFound' }
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "error" */ '../components/Error404/Error404.vue'),
    meta: { hideNavFooter: true, seoKey: 'notFound' }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: 'smooth' };
    return { top: 0, behavior: 'smooth' };
  }
})

// Dynamic SEO meta tags per route (bilingual)
router.afterEach((to) => {
  const seo = getSeo(to.meta.seoKey);
  document.title = seo.title || 'RUCSCO | Integrated Business Solutions';

  const lang = localStorage.getItem('lang') || 'en';
  document.documentElement.setAttribute('lang', lang);

  const setMeta = (name, content) => {
    if (!content) return;
    let el = document.querySelector(`meta[name="${name}"]`);
    if (el) {
      el.setAttribute('content', content);
    } else {
      el = document.createElement('meta');
      el.setAttribute('name', name);
      el.setAttribute('content', content);
      document.head.appendChild(el);
    }
  };

  const setOg = (property, content) => {
    if (!content) return;
    let el = document.querySelector(`meta[property="${property}"]`);
    if (el) {
      el.setAttribute('content', content);
    } else {
      el = document.createElement('meta');
      el.setAttribute('property', property);
      el.setAttribute('content', content);
      document.head.appendChild(el);
    }
  };

  setMeta('description', seo.description);
  setMeta('keywords', seo.keywords);
  setOg('og:title', seo.title);
  setOg('og:description', seo.description);
  setOg('og:url', window.location.href);
  setOg('og:locale', lang === 'ar' ? 'ar_AR' : 'en_US');
  setMeta('twitter:title', seo.title);
  setMeta('twitter:description', seo.description);
})

export default router
